import { render, staticRenderFns } from "./ScreenAuthenticated.vue?vue&type=template&id=089f4228&scoped=true&"
import script from "./ScreenAuthenticated.vue?vue&type=script&lang=js&"
export * from "./ScreenAuthenticated.vue?vue&type=script&lang=js&"
import style0 from "./ScreenAuthenticated.vue?vue&type=style&index=0&id=089f4228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089f4228",
  null
  
)

export default component.exports